export const demographicsFieldDefinitions = [
  {
    key: 'total_population',
    label: 'Total Population',
    format: 'number',
    category: 'population',
    showInOverview: true
  },
  {
    key: 'total_population_eth',
    dataKey: 'total_population',
    label: 'Total Population',
    format: 'number',
    category: 'ethnicity'
  },
  {
    key: 'total_households',
    label: 'Total Households',
    format: 'number',
    category: 'households'
  },
  {
    key: 'persons_per_household',
    label: 'Persons Per Household',
    format: 'decimal',
    category: 'households'
  },
  {
    key: 'average_household_income',
    label: 'Average Household Income',
    format: 'currency',
    category: 'household_income',
    showInOverview: true
  },
  {
    key: 'per_capita_income',
    label: 'Per Capita Income',
    format: 'currency',
    category: 'household_income'
  },
  {
    key: 'income_less_than_15k',
    dataKey: 'household_income_stat.incomeLessThan15k',
    label: '<$15,000',
    format: 'number',
    category: 'household_income'
  },
  {
    key: 'income_15k_to_24_999',
    dataKey: 'household_income_stat.income15kTo24999',
    label: '$15,000–$24,999',
    format: 'number',
    category: 'household_income'
  },
  {
    key: 'income_25k_to_34_999',
    dataKey: 'household_income_stat.income25kTo34999',
    label: '$25,000–$34,999',
    format: 'number',
    category: 'household_income'
  },
  {
    key: 'income_35k_to_49_999',
    dataKey: 'household_income_stat.income35kTo49999',
    label: '$35,000–$49,999',
    format: 'number',
    category: 'household_income'
  },
  {
    key: 'income_50k_to_74_999',
    dataKey: 'household_income_stat.income50kTo74999',
    label: '$50,000–$74,999',
    format: 'number',
    category: 'household_income'
  },
  {
    key: 'income_75k_to_99_999',
    dataKey: 'household_income_stat.income75kTo99999',
    label: '$75,000–$99,999',
    format: 'number',
    category: 'household_income'
  },
  {
    key: 'income_100k_to_124_999',
    dataKey: 'household_income_stat.income100kTo124999',
    label: '$100,000–$124,999',
    format: 'number',
    category: 'household_income'
  },
  {
    key: 'income_125k_to_149_999',
    dataKey: 'household_income_stat.income125kTo149999',
    label: '$125,000–$149,999',
    format: 'number',
    category: 'household_income'
  },
  {
    key: 'income_150k_to_199_999',
    dataKey: 'household_income_stat.income150kTo199999',
    label: '$150,000–$199,999',
    format: 'number',
    category: 'household_income'
  },
  {
    key: 'income_200k_plus',
    dataKey: 'household_income_stat.income200kPlus',
    label: '$200,000+',
    format: 'number',
    category: 'household_income'
  },
  {
    key: 'average_house_value',
    label: 'Average House Value',
    format: 'currency',
    category: 'housing_units',
    showInOverview: true
  },
  { key: 'average_age', label: 'Average Age', format: 'decimal', category: 'age' },
  {
    key: 'average_age_male',
    label: 'Average Age (Male)',
    format: 'decimal',
    category: 'age'
  },
  {
    key: 'average_age_female',
    label: 'Average Age (Female)',
    format: 'decimal',
    category: 'age'
  },
  {
    key: 'population_hispanic',
    label: 'Hispanic Population',
    format: 'number',
    category: 'ethnicity'
  },
  {
    key: 'population_non_hispanic',
    label: 'Non-Hispanic Population',
    format: 'number',
    category: 'ethnicity'
  },
  {
    key: 'population_white',
    label: 'White Population',
    format: 'number',
    category: 'ethnicity'
  },
  {
    key: 'population_black',
    label: 'Black Population',
    format: 'number',
    category: 'ethnicity'
  },
  {
    key: 'population_american_indian',
    label: 'American Indian Population',
    format: 'number',
    category: 'ethnicity'
  },
  {
    key: 'population_asian',
    label: 'Asian Population',
    format: 'number',
    category: 'ethnicity'
  },
  {
    key: 'population_pacific_islander',
    label: 'Pacific Islander Population',
    format: 'number',
    category: 'ethnicity'
  },
  {
    key: 'population_other',
    label: 'Other Race Population',
    format: 'number',
    category: 'ethnicity'
  },
  {
    key: 'male_total',
    dataKey: 'population_stat.maleTotal',
    label: 'Male',
    format: 'number',
    category: 'gender'
  },
  {
    key: 'female_total',
    dataKey: 'population_stat.femaleTotal',
    label: 'Female',
    format: 'number',
    category: 'gender'
  },
  {
    key: 'age_0_4',
    dataKey: 'population_stat.age04',
    label: 'Age 0 - 4',
    format: 'number',
    category: 'age',
    showInOverview: true
  },
  {
    key: 'age_5_9',
    dataKey: 'population_stat.age59',
    label: 'Age 5 - 9',
    format: 'number',
    category: 'age',
    showInOverview: true
  },
  {
    key: 'age_10_14',
    dataKey: 'population_stat.age1014',
    label: 'Age 10 - 14',
    format: 'number',
    category: 'age',
    showInOverview: true
  },
  {
    key: 'age_15_17',
    dataKey: 'population_stat.age1517',
    label: 'Age 15 - 17',
    format: 'number',
    category: 'age',
    showInOverview: true
  },
  {
    key: 'age_18_20',
    dataKey: 'population_stat.age1820',
    label: 'Age 18 - 20',
    format: 'number',
    category: 'age',
    showInOverview: true
  },
  {
    key: 'age_21_24',
    dataKey: 'population_stat.age2124',
    label: 'Age 21 - 24',
    format: 'number',
    category: 'age',
    showInOverview: true
  },
  {
    key: 'age_25_34',
    dataKey: 'population_stat.age2534',
    label: 'Age 25 - 34',
    format: 'number',
    category: 'age',
    showInOverview: true
  },
  {
    key: 'age_35_44',
    dataKey: 'population_stat.age3544',
    label: 'Age 35 - 44',
    format: 'number',
    category: 'age',
    showInOverview: true
  },
  {
    key: 'age_45_54',
    dataKey: 'population_stat.age4554',
    label: 'Age 45 - 54',
    format: 'number',
    category: 'age',
    showInOverview: true
  },
  {
    key: 'age_55_64',
    dataKey: 'population_stat.age5564',
    label: 'Age 55 - 64',
    format: 'number',
    category: 'age',
    showInOverview: true
  },
  {
    key: 'age_65_74',
    dataKey: 'population_stat.age6574',
    label: 'Age 65 - 74',
    format: 'number',
    category: 'age',
    showInOverview: true
  },
  {
    key: 'age_75_84',
    dataKey: 'population_stat.age7584',
    label: 'Age 75 - 84',
    format: 'number',
    category: 'age',
    showInOverview: true
  },
  {
    key: 'age_85_plus',
    dataKey: 'population_stat.age85Plus',
    label: 'Age 85+',
    format: 'number',
    category: 'age',
    showInOverview: true
  },
  {
    key: 'less_than_9th_grade',
    dataKey: 'educational_attainment_stat.lessThan9thGrade',
    label: 'Less than 9th Grade',
    format: 'number',
    category: 'education'
  },
  {
    key: 'no_high_school_degree',
    dataKey: 'educational_attainment_stat.noHighSchoolDegree',
    label: 'No High School Degree',
    format: 'number',
    category: 'education'
  },
  {
    key: 'high_school_graduate',
    dataKey: 'educational_attainment_stat.highSchoolGraduate',
    label: 'High School Graduate',
    format: 'number',
    category: 'education'
  },
  {
    key: 'some_college',
    dataKey: 'educational_attainment_stat.someCollege',
    label: 'Some College, No Degree',
    format: 'number',
    category: 'education'
  },
  {
    key: 'associates_degree',
    dataKey: 'educational_attainment_stat.associatesDegree',
    label: 'Associates Degree',
    format: 'number',
    category: 'education'
  },
  {
    key: 'bachelors_degree',
    dataKey: 'educational_attainment_stat.bachelorsDegree',
    label: 'Bachelors Degree',
    format: 'number',
    category: 'education'
  },
  {
    key: 'masters_degree',
    dataKey: 'educational_attainment_stat.mastersDegree',
    label: 'Masters Degree',
    format: 'number',
    category: 'education'
  },
  {
    key: 'professional_degree',
    dataKey: 'educational_attainment_stat.professionalDegree',
    label: 'Professional Degree',
    format: 'number',
    category: 'education'
  },
  {
    key: 'doctorate_degree',
    dataKey: 'educational_attainment_stat.doctorateDegree',
    label: 'Doctorate Degree',
    format: 'number',
    category: 'education'
  },
  {
    key: 'two_or_more_races',
    dataKey: 'race_stat.twoOrMoreRaces',
    label: '2+ Races',
    format: 'number',
    category: 'ethnicity'
  },
  {
    key: 'total_housing_units',
    dataKey: 'occupancy_status_stat.total',
    label: 'Total Housing Units',
    format: 'number',
    category: 'housing_units'
  },
  {
    key: 'vacant',
    dataKey: 'occupancy_status_stat.vacant',
    label: 'Vacant Housing Units',
    format: 'number',
    category: 'housing_units'
  },
  {
    key: 'owner_occupied',
    dataKey: 'tenure_stat.ownerOccupied',
    label: 'Owner Occupied',
    format: 'number',
    category: 'housing_units'
  },
  {
    key: 'renter_occupied',
    dataKey: 'tenure_stat.renterOccupied',
    label: 'Renter Occupied',
    format: 'number',
    category: 'housing_units'
  },
  {
    key: 'employed',
    dataKey: 'employment_status_stat.employed',
    label: 'Civilian Labor Force - Employed',
    format: 'number',
    category: 'labor_force',
    showInOverview: true
  },
  {
    key: 'unemployed',
    dataKey: 'employment_status_stat.unemployed',
    label: 'Civilian Labor Force - Unemployed',
    format: 'number',
    category: 'labor_force',
    showInOverview: true
  },
  {
    key: 'armed_forces',
    dataKey: 'employment_status_stat.armedForces',
    label: 'Armed Forces',
    format: 'number',
    category: 'labor_force'
  },
  {
    key: 'not_in_labor_force',
    dataKey: 'employment_status_stat.notInLaborForce',
    label: 'Not in Labor Force',
    format: 'number',
    category: 'labor_force'
  },
  {
    key: 'average_travel_time',
    dataKey: 'travel_time_to_work_stat.averageTravelTime',
    label: 'Average Travel Time',
    format: 'number',
    category: 'travel_time_to_work'
  },
  {
    key: 'less_than_15_min',
    dataKey: 'travel_time_to_work_stat.lessThan15Min',
    label: 'Less than 15 min',
    format: 'number',
    category: 'travel_time_to_work'
  },
  {
    key: 'minutes_15_to_29',
    dataKey: 'travel_time_to_work_stat.minutes15To29',
    label: '15 - 29 min',
    format: 'number',
    category: 'travel_time_to_work'
  },
  {
    key: 'minutes_30_to_44',
    dataKey: 'travel_time_to_work_stat.minutes30To44',
    label: '30 - 44 min',
    format: 'number',
    category: 'travel_time_to_work'
  },
  {
    key: 'minutes_45_to_59',
    dataKey: 'travel_time_to_work_stat.minutes45To59',
    label: '45 - 59 min',
    format: 'number',
    category: 'travel_time_to_work'
  },
  {
    key: 'minutes_60_plus',
    dataKey: 'travel_time_to_work_stat.minutes60Plus',
    label: '60+ min',
    format: 'number',
    category: 'travel_time_to_work'
  },
  {
    key: 'single_detached',
    dataKey: 'units_in_structure_stat.singleDetached',
    label: 'Single Unit Detached',
    format: 'number',
    category: 'types_of_housing_units'
  },
  {
    key: 'single_attached',
    dataKey: 'units_in_structure_stat.singleAttached',
    label: 'Single Unit Attached',
    format: 'number',
    category: 'types_of_housing_units'
  },
  {
    key: 'two_units',
    dataKey: 'units_in_structure_stat.twoUnits',
    label: '2 Units',
    format: 'number',
    category: 'types_of_housing_units'
  },
  {
    key: 'three_or_four_units',
    dataKey: 'units_in_structure_stat.threeOrFourUnits',
    label: '3 to 4 Units',
    format: 'number',
    category: 'types_of_housing_units'
  },
  {
    key: 'five_to_nine_units',
    dataKey: 'units_in_structure_stat.fiveToNineUnits',
    label: '5 to 9 Units',
    format: 'number',
    category: 'types_of_housing_units'
  },
  {
    key: 'ten_to_nineteen_units',
    dataKey: 'units_in_structure_stat.tenToNineteenUnits',
    label: '10 to 19 Units',
    format: 'number',
    category: 'types_of_housing_units'
  },
  {
    key: 'twenty_to_forty_nine_units',
    dataKey: 'units_in_structure_stat.twentyToFortyNineUnits',
    label: '20 to 49 Units',
    format: 'number',
    category: 'types_of_housing_units'
  },
  {
    key: 'fifty_or_more_units',
    dataKey: 'units_in_structure_stat.fiftyOrMoreUnits',
    label: '50+ Units',
    format: 'number',
    category: 'types_of_housing_units'
  },
  {
    key: 'mobile_home',
    dataKey: 'units_in_structure_stat.mobileHome',
    label: 'Mobile Home',
    format: 'number',
    category: 'types_of_housing_units'
  },
  {
    key: 'boat_rv_van_etc',
    dataKey: 'units_in_structure_stat.boatRvVanEtc',
    label: 'Other',
    format: 'number',
    category: 'types_of_housing_units'
  },
  {
    key: 'accommodation_food_services',
    dataKey: 'industry_stat.accommodationFoodServices',
    label: 'Accommodation and Food Services',
    format: 'number',
    category: 'population_by_industry'
  },
  {
    key: 'admin_support_waste_mgmt',
    dataKey: 'industry_stat.adminSupportWasteMgmt',
    label: 'Administrative and Support and Waste Management',
    format: 'number',
    category: 'population_by_industry'
  },
  {
    key: 'agriculture_forestry_fishing_hunting_mining',
    dataKey: 'industry_stat.agricultureForestryFishingHuntingMining',
    label: 'Agriculture, Forestry, Fishing, Hunting, and Mining',
    format: 'number',
    category: 'population_by_industry'
  },
  {
    key: 'arts_entertainment_recreation',
    dataKey: 'industry_stat.artsEntertainmentRecreation',
    label: 'Arts, Entertainment, and Recreation',
    format: 'number',
    category: 'population_by_industry'
  },
  {
    key: 'construction',
    dataKey: 'industry_stat.construction',
    label: 'Construction',
    format: 'number',
    category: 'population_by_industry'
  },
  {
    key: 'educational_services',
    dataKey: 'industry_stat.educationalServices',
    label: 'Educational Services',
    format: 'number',
    category: 'population_by_industry'
  },
  {
    key: 'finance_insurance_real_estate',
    dataKey: 'industry_stat.financeInsuranceRealEstate',
    label: 'Finance, Insurance, and Real Estate',
    format: 'number',
    category: 'population_by_industry'
  },
  {
    key: 'healthcare_social_assistance',
    dataKey: 'industry_stat.healthcareSocialAssistance',
    label: 'Health Care and Social Assistance',
    format: 'number',
    category: 'population_by_industry'
  },
  {
    key: 'information',
    dataKey: 'industry_stat.information',
    label: 'Information',
    format: 'number',
    category: 'population_by_industry'
  },
  {
    key: 'management_of_companies',
    dataKey: 'industry_stat.managementOfCompanies',
    label: 'Management of Companies',
    format: 'number',
    category: 'population_by_industry'
  },
  {
    key: 'manufacturing',
    dataKey: 'industry_stat.manufacturing',
    label: 'Manufacturing',
    format: 'number',
    category: 'population_by_industry'
  },
  {
    key: 'other_services_except_public_admin',
    dataKey: 'industry_stat.otherServicesExceptPublicAdmin',
    label: 'Other Services (Except Public Administration)',
    format: 'number',
    category: 'population_by_industry'
  },
  {
    key: 'professional_scientific_technical',
    dataKey: 'industry_stat.professionalScientificTechnical',
    label: 'Professional, Scientific, and Technical Services',
    format: 'number',
    category: 'population_by_industry'
  },
  {
    key: 'public_administration',
    dataKey: 'industry_stat.publicAdministration',
    label: 'Public Administration',
    format: 'number',
    category: 'population_by_industry'
  },
  {
    key: 'retail_trade',
    dataKey: 'industry_stat.retailTrade',
    label: 'Retail Trade',
    format: 'number',
    category: 'population_by_industry'
  },
  {
    key: 'transportation_warehousing_utilities',
    dataKey: 'industry_stat.transportationWarehousingUtilities',
    label: 'Transportation, Warehousing, and Utilities',
    format: 'number',
    category: 'population_by_industry'
  },
  {
    key: 'wholesale_trade',
    dataKey: 'industry_stat.wholesaleTrade',
    label: 'Wholesale Trade',
    format: 'number',
    category: 'population_by_industry'
  },
  {
    key: 'architecture_engineering',
    dataKey: 'occupation_stat.architectureEngineering',
    label: 'Architecture and Engineering',
    format: 'number',
    category: 'population_by_occupation'
  },
  {
    key: 'arts_design_entertainment_sports_media',
    dataKey: 'occupation_stat.artsDesignEntertainmentSportsMedia',
    label: 'Arts, Entertainment, and Sports',
    format: 'number',
    category: 'population_by_occupation'
  },
  {
    key: 'building_grounds_maintenance',
    dataKey: 'occupation_stat.buildingGroundsMaintenance',
    label: 'Building and Grounds Maintenance',
    format: 'number',
    category: 'population_by_occupation'
  },
  {
    key: 'business_financial_operations',
    dataKey: 'occupation_stat.businessFinancialOperations',
    label: 'Business and Financial Operations',
    format: 'number',
    category: 'population_by_occupation'
  },
  {
    key: 'community_social_service',
    dataKey: 'occupation_stat.communitySocialService',
    label: 'Community and Social Services',
    format: 'number',
    category: 'population_by_occupation'
  },
  {
    key: 'computer_mathematical',
    dataKey: 'occupation_stat.computerMathematical',
    label: 'Computer and Mathematical',
    format: 'number',
    category: 'population_by_occupation'
  },
  {
    key: 'construction_extraction',
    dataKey: 'occupation_stat.constructionExtraction',
    label: 'Construction and Extraction',
    format: 'number',
    category: 'population_by_occupation'
  },
  {
    key: 'education_library',
    dataKey: 'occupation_stat.educationLibrary',
    label: 'Education, Training, and Library',
    format: 'number',
    category: 'population_by_occupation'
  },
  {
    key: 'farming_fishing_forestry',
    dataKey: 'occupation_stat.farmingFishingForestry',
    label: 'Farming, Fishing, and Forestry',
    format: 'number',
    category: 'population_by_occupation'
  },
  {
    key: 'food_preparation_serving',
    dataKey: 'occupation_stat.foodPreparationServing',
    label: 'Food Preparation and Serving',
    format: 'number',
    category: 'population_by_occupation'
  },
  {
    key: 'healthcare_practitioners_technical',
    dataKey: 'occupation_stat.healthcarePractitionersTechnical',
    label: 'Health Practitioners and Technical',
    format: 'number',
    category: 'population_by_occupation'
  },
  {
    key: 'healthcare_support',
    dataKey: 'occupation_stat.healthcareSupport',
    label: 'Healthcare Support',
    format: 'number',
    category: 'population_by_occupation'
  },
  {
    key: 'installation_maintenance_repair',
    dataKey: 'occupation_stat.installationMaintenanceRepair',
    label: 'Maintenance and Repair',
    format: 'number',
    category: 'population_by_occupation'
  },
  {
    key: 'legal',
    dataKey: 'occupation_stat.legal',
    label: 'Legal',
    format: 'number',
    category: 'population_by_occupation'
  },
  {
    key: 'life_physical_social_science',
    dataKey: 'occupation_stat.lifePhysicalSocialScience',
    label: 'Life, Physical, and Social Science',
    format: 'number',
    category: 'population_by_occupation'
  },
  {
    key: 'management',
    dataKey: 'occupation_stat.management',
    label: 'Management',
    format: 'number',
    category: 'population_by_occupation'
  },
  {
    key: 'office_admin_support',
    dataKey: 'occupation_stat.officeAdminSupport',
    label: 'Office and Administrative Support',
    format: 'number',
    category: 'population_by_occupation'
  },
  {
    key: 'worked_from_home',
    dataKey: 'means_of_transportation_stat.workedFromHome',
    label: 'Worked at Home',
    format: 'number',
    category: 'transportation_to_work'
  },
  {
    key: 'walked',
    dataKey: 'means_of_transportation_stat.walked',
    label: 'Walked',
    format: 'number',
    category: 'transportation_to_work'
  },
  {
    key: 'bicycle',
    dataKey: 'means_of_transportation_stat.bicycle',
    label: 'Bicycle',
    format: 'number',
    category: 'transportation_to_work'
  },
  {
    key: 'car_truck_van_carpool_total',
    dataKey: 'means_of_transportation_stat.carTruckVanCarpoolTotal',
    label: 'Carpooled',
    format: 'number',
    category: 'transportation_to_work'
  },
  {
    key: 'car_truck_van_drove_alone',
    dataKey: 'means_of_transportation_stat.carTruckVanDroveAlone',
    label: 'Drove Alone',
    format: 'number',
    category: 'transportation_to_work'
  },
  {
    key: 'public_transportation_total',
    dataKey: 'means_of_transportation_stat.publicTransportationTotal',
    label: 'Public Transport',
    format: 'number',
    category: 'transportation_to_work'
  },
  {
    key: 'other_means',
    dataKey: 'means_of_transportation_stat.otherMeans',
    label: 'Other',
    format: 'number',
    category: 'transportation_to_work'
  },
  {
    key: 'less_than_20k',
    dataKey: 'housing_value_stat.lessThan20k',
    label: 'Less than $20,000',
    format: 'number',
    category: 'value_of_owner_occupied_housing_units'
  },
  {
    key: 'from_20k_to_39_999',
    dataKey: 'housing_value_stat.from20kTo39999',
    label: '$20,000-$39,999',
    format: 'number',
    category: 'value_of_owner_occupied_housing_units'
  },
  {
    key: 'from_40k_to_59_999',
    dataKey: 'housing_value_stat.from40kTo59999',
    label: '$40,000-$59,999',
    format: 'number',
    category: 'value_of_owner_occupied_housing_units'
  },
  {
    key: 'from_60k_to_79_999',
    dataKey: 'housing_value_stat.from60kTo79999',
    label: '$60,000-$79,999',
    format: 'number',
    category: 'value_of_owner_occupied_housing_units'
  },
  {
    key: 'from_80k_to_99_999',
    dataKey: 'housing_value_stat.from80kTo99999',
    label: '$80,000-$99,999',
    format: 'number',
    category: 'value_of_owner_occupied_housing_units'
  },
  {
    key: 'from_100k_to_149_999',
    dataKey: 'housing_value_stat.from100kTo149999',
    label: '$100,000-$149,999',
    format: 'number',
    category: 'value_of_owner_occupied_housing_units'
  },
  {
    key: 'from_150k_to_199_999',
    dataKey: 'housing_value_stat.from150kTo199999',
    label: '$150,000-$199,999',
    format: 'number',
    category: 'value_of_owner_occupied_housing_units'
  },
  {
    key: 'from_200k_to_299_999',
    dataKey: 'housing_value_stat.from200kTo299999',
    label: '$200,000-$299,999',
    format: 'number',
    category: 'value_of_owner_occupied_housing_units'
  },
  {
    key: 'from_300k_to_399_999',
    dataKey: 'housing_value_stat.from300kTo399999',
    label: '$300,000-$399,999',
    format: 'number',
    category: 'value_of_owner_occupied_housing_units'
  },
  {
    key: 'from_400k_to_499_999',
    dataKey: 'housing_value_stat.from400kTo499999',
    label: '$400,000-$499,999',
    format: 'number',
    category: 'value_of_owner_occupied_housing_units'
  },
  {
    key: 'from_500k_to_749_999',
    dataKey: 'housing_value_stat.from500kTo749999',
    label: '$500,000-$749,999',
    format: 'number',
    category: 'value_of_owner_occupied_housing_units'
  },
  {
    key: 'from_750k_to_999_999',
    dataKey: 'housing_value_stat.from750kTo999999',
    label: '$750,000-$999,999',
    format: 'number',
    category: 'value_of_owner_occupied_housing_units'
  },
  {
    key: 'from_1m_to_1_499_999',
    dataKey: 'housing_value_stat.from1mTo1499999',
    label: '$1,000,000-$1,499,999',
    format: 'number',
    category: 'value_of_owner_occupied_housing_units'
  },
  {
    key: 'from_1_5m_to_1_999_999',
    dataKey: 'housing_value_stat.from15mTo1999999',
    label: '$1,500,000-$1,999,999',
    format: 'number',
    category: 'value_of_owner_occupied_housing_units'
  },
  {
    key: 'from_2m_or_more',
    dataKey: 'housing_value_stat.from2mOrMore',
    label: '$2,000,000 or more',
    format: 'number',
    category: 'value_of_owner_occupied_housing_units'
  },
  {
    key: 'median_value',
    dataKey: 'housing_value_stat.medianValue',
    label: 'Median Value',
    format: 'currency',
    category: 'value_of_owner_occupied_housing_units'
  },
  {
    key: 'average_value',
    dataKey: 'housing_value_stat.averageValue',
    label: 'Average Value',
    format: 'currency',
    category: 'value_of_owner_occupied_housing_units'
  },
  {
    key: 'never_married',
    dataKey: 'marital_stat.neverMarried',
    label: 'Never Married',
    format: 'number',
    category: 'marital_status'
  },
  {
    key: 'married_spouse_present',
    dataKey: 'marital_stat.marriedSpousePresent',
    label: 'Married - Spouse Present',
    format: 'number',
    category: 'marital_status'
  },
  {
    key: 'married_spouse_absent',
    dataKey: 'marital_stat.marriedSpouseAbsent',
    label: 'Married - Spouse Absent',
    format: 'number',
    category: 'marital_status'
  },
  {
    key: 'divorced',
    dataKey: 'marital_stat.divorced',
    label: 'Divorced',
    format: 'number',
    category: 'marital_status'
  },
  {
    key: 'widowed',
    dataKey: 'marital_stat.widowed',
    label: 'Widowed',
    format: 'number',
    category: 'marital_status'
  }
];
